import '@styles/pages/search.scss';

import { pinia } from '@tools/pinia';
import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import { primevueConfig } from '@config/primevue';
import { hasFeatureFlag } from '@tools/featureFlag.ts';
import { FeatureFlag } from '@enums/featureFlag.ts';

import { initSelectionBusHandler } from '@organisms/selection-bus-handler';
import { selectionSliderManager } from '@organisms/selection-slider-manager';
import { googlePlacesHelpers } from '@tools/geoservices/google-places-helpers';
import Search from './search/Search.vue';

if (hasFeatureFlag(FeatureFlag.NEW_SEARCH)) {
  createApp(Search)
    .use(pinia)
    .use(PrimeVue, primevueConfig)
    .mount('#search-app');
} else {
  // @ts-expect-error it will be removed later, @see https://bureaux-a-partager.atlassian.net/browse/MATCH-10570
  window.googlePlacesHelpers = googlePlacesHelpers;

  initSelectionBusHandler();
  selectionSliderManager();
}
